// Zod probes `new Function('')` at schema construction time to decide whether to JIT-compile
// its fast parse path. The probe swallows the throw, but a strict CSP still reports it as a
// script-src `eval` violation. `jitless` skips the probe and uses the interpreted path.
//
// Must be evaluated before the first schema is constructed: `@json-render/core` builds its
// schemas at module load, and the JIT decision is cached per schema at construction, not at parse.
import { config } from 'zod';

config({ jitless: true });
